import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getHrSafetyReps,
  registerSafetyRep,
  removeSafetyRep,
  SafetyRepRegistration,
  updateSafetyRepTeams,
} from '../../../api/hrSafetyReps';
import { HrWorkEnvironmentOverviewQueryKey } from './useHrWorkEnvironmentOverviewQuery';

export const HrSafetyRepsQueryKey = 'HR_SAFETY_REPS';

export const useHrSafetyRepsQuery = () =>
  useQuery({ queryKey: [HrSafetyRepsQueryKey], queryFn: getHrSafetyReps });

/** Who is safety representative changes what the overview says is missing */
const useSafetyRepMutation = <T>(run: (input: T) => Promise<void>) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: run,
    onSuccess: () =>
      Promise.all(
        [HrSafetyRepsQueryKey, HrWorkEnvironmentOverviewQueryKey].map((key) =>
          queryClient.invalidateQueries({ queryKey: [key] }),
        ),
      ),
  });
};

export const useRegisterSafetyRepMutation = () =>
  useSafetyRepMutation((registration: SafetyRepRegistration) =>
    registerSafetyRep(registration),
  );

export const useUpdateSafetyRepTeamsMutation = () =>
  useSafetyRepMutation(
    ({ userId, teamIds }: { userId: number; teamIds: number[] }) =>
      updateSafetyRepTeams(userId, teamIds),
  );

export const useRemoveSafetyRepMutation = () =>
  useSafetyRepMutation((userId: number) => removeSafetyRep(userId));
